<template>
  <TsTypography>
    <div v-html="props.visibleText" />
    <span v-if="is_read_more">
      <div v-html="props.readMoreText" />
    </span>
    <span
        v-if="props.readMoreText"
        class="text-info underline text-nowrap cursor-pointer"
        @click="toggleReadMore"
    >
        {{ is_read_more ? "Read less" : "Read more"}}
      </span>
  </TsTypography>
</template>

<script setup lang="ts">

type Props = {
  visibleText?: string;
  readMoreText?: string;
}

const props = withDefaults(defineProps<Props>(), {
  visibleText: "This is the default visible text.",
  readMoreText: "This is the default read more text."
})

const is_read_more = ref(false);

const toggleReadMore = () => {
  is_read_more.value = !is_read_more.value
}
</script>